import { Box } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";

export const LogoMark = ({ size = "32px" }: { size?: string }) => (
	<svg
		aria-hidden
		width={size}
		height={size}
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ display: "block", flexShrink: 0 }}
	>
		<rect width="32" height="32" rx="8" fill="#27445D" style={{ fill: "var(--ds-logo-bg, #27445D)" }} />
		<path d="M6 10H26" stroke="#CBD5E1" strokeWidth="2" style={{ stroke: "var(--ds-logo-line, #CBD5E1)" }} />
		<rect x="6" y="14" width="8" height="4" rx="1" fill="white" />
		<rect x="6" y="22" width="20" height="2" rx="1" fill="#E5E7EB" />
	</svg>
);

export const Logo = ({ color = "#1F2937" }: { color?: string }) => (
	<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
		<LogoMark />
		<Typo variant="head" sx={{ color, fontSize: "22px", fontWeight: 800 }}>
			CardPartner
		</Typo>
	</Box>
);
